import { notification } from 'antd';
import { IconType } from 'antd/lib/notification';

type MESSAGE = {
    [key in IconType]: string;
};
const MESSAGE_TYPE: MESSAGE = {
    error: 'Failed',
    info: 'Info',
    success: 'Success',
    warning: 'Warning',
};

const NOTIFICATION_COLOR: MESSAGE = {
    error: '#FFD8E1',
    info: '',
    success: '#E6F8E3',
    warning: '',
};

const useOrderToast = () => {
    const toast = (
        message: string,
        type: IconType,
        duration: number = 2,
        onClose?: () => void,
    ) => {
        const errorMessage = MESSAGE_TYPE[type];
        const bgColor = NOTIFICATION_COLOR[type];
        notification.open({
            style: {
                borderRadius: 15,
                ...(bgColor ? { backgroundColor: bgColor } : {}),
            },
            type: type,
            message: errorMessage,
            description: message,
            placement: 'bottomRight',
            duration: duration,
            onClose: onClose,
        });
    };

    return { toast };
};

export default useOrderToast;
